import { render, staticRenderFns } from "./SummaryForm.vue?vue&type=template&id=38c8bf22"
import script from "./SummaryForm.vue?vue&type=script&lang=js"
export * from "./SummaryForm.vue?vue&type=script&lang=js"
import style0 from "./SummaryForm.vue?vue&type=style&index=0&id=38c8bf22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports